<template>
  <div>
    <h2>
      Lista zaufanych IP, które bedą pomijane w przypadku limitów liczby zapytań
      na API na sekunde
    </h2>
    <v-btn color="primary" @click="openCreateDialog">Nowy</v-btn>
    <DataTable :headers="headers" :items="items">
      <template v-slot:item.actions="{ item }">
        <v-btn color="error" @click="openDeleteDialog(item)"
          ><v-icon>fa-trash</v-icon></v-btn
        >
      </template></DataTable
    >
    <v-dialog v-model="createDialog" persistent width="800">
      <v-card>
        <v-card-title>Nowy</v-card-title>
        <v-card-text
          ><v-text-field label="IP" v-model="createVm.ip"></v-text-field
          ><v-text-field
            label="opis"
            v-model="createVm.description"
          ></v-text-field
        ></v-card-text>
        <v-card-actions
          ><v-btn color="primary" @click="create">Zapisz</v-btn
          ><v-btn color="error" @click="closeCreateDialog"
            >Anuluj</v-btn
          ></v-card-actions
        >
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" persistent width="800">
      <v-card>
        <v-card-title>Usuń</v-card-title>
        <v-card-text>
          {{ deleteVm.ip }} {{ deleteVm.description }}
        </v-card-text>
        <v-card-actions
          ><v-btn color="error" @click="deleteItem">Usuń</v-btn
          ><v-btn color="primary" @click="closeDeleteDialog"
            >Anuluj</v-btn
          ></v-card-actions
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      createDialog: false,
      deleteDialog: false,
      deleteVm: {},
      createVm: {},
      items: [],
      headers: [
        {
          text: "Id",
          value: "id",
        },
        {
          text: "Ip",
          value: "ip",
        },
        {
          text: "Opis",
          value: "description",
        },
        {
          text: "Opcje",
          value: "actions",
        },
      ],
    };
  },
  async mounted() {
    await this.getList();
  },
  methods: {
    async getList() {
      const { data } = await this.$http.get("IpWhiteList/GetGlobalWhiteList");
      this.items = data;
    },
    async create() {
      await this.$http.post("IpWhiteList/CreateGlobalWhiteList", this.createVm);
      this.createDialog = false;
      this.createVm = {};
      await this.getList();
    },
    async deleteItem() {
      await this.$http.delete(
        "IpWhiteList/DeleteGlobalWhiteList?id=" + this.deleteVm.id
      );
      this.deleteDialog = false;
      this.deleteVm = {};
      await this.getList();
    },
    openCreateDialog() {
      this.createVm = {};
      this.createDialog = true;
    },
    closeCreateDialog() {
      this.createVm = {};
      this.createDialog = false;
    },
    openDeleteDialog(item) {
      this.deleteVm = item;
      this.deleteDialog = true;
    },
    closeDeleteDialog() {
      this.deleteVm = {};
      this.deleteDialog = false;
    },
  },
};
</script>